import { UserInformation } from "lib/services/user-information-service";

import jobFamiliesMapping from "../../configuration/AIForMe/jobFamiliesMapping.json";

export const getJobFamilyNameFromMap = async () => {
  const userInfo = await UserInformation.current.getUserInformation();
  if (userInfo && userInfo.jobInfo && userInfo.jobInfo.jobFamilyName) {
    return (jobFamiliesMapping as { [key: string]: string })[userInfo.jobInfo.jobFamilyName];
  }
  return undefined;
};
